/**
 * @description Module Sondage
 *
 */

/* global ModuloTS jQuery Drupal drupalSettings */

(function ($, Drupal) {
	'use strict';

	Drupal.behaviors.sondage = {
		attach: function (context) {
			const sondageResult = () => {
				if (document.querySelector('.sondage-resultats')) {
					document
						.querySelector('.poll-view-form')
						.classList.add('form--result');

					setTimeout(() => {
						document
							.querySelector('.sondage-resultats__thanks')
							.focus();
					}, 500);
				}
			};
			const inputClick = () => {
				if (document.querySelector('[data-drupal-messages]')) {
					if (document.querySelector('.sondage-resultats__thanks')) {
						document.querySelector(
							'.sondage-resultats__thanks p'
						).innerText =
							ModuloTS['thank you for your participation'];
						document
							.querySelector('[data-drupal-messages] [data-type]')
							.setAttribute('tabindex', '-1');
						document
							.querySelector('.sondage-resultats__thanks')
							.parentNode.querySelector(
								'[data-drupal-messages] [data-type]'
							)
							.focus();
						document
							.querySelector('.sondage-resultats__thanks i')
							.setAttribute('data-icon', 'check');

						document
							.querySelector('.form--result .form-actions')
							.classList.add('canceled');
					}
				} else if (
					document.querySelector('.sondage-resultats__thanks') &&
					document.querySelector('.form--result .form-actions')
				) {
					document.querySelector(
						'.sondage-resultats__thanks p'
					).innerText = ModuloTS['Current votes'];

					document
						.querySelector('.sondage-resultats__thanks i')
						.setAttribute('data-icon', 'elections');
				} else {
					if (
						document.querySelector('.sondage-resultats__thanks p')
					) {
						document.querySelector(
							'.sondage-resultats__thanks p'
						).innerText = ModuloTS['Survey closed'];

						document
							.querySelector('.sondage-resultats__thanks i')
							.setAttribute('data-icon', 'lock');
					}
				}
			};
			const inputCheck = () => {
				document
					.querySelectorAll('.vote-form .form-group')
					.forEach((checkBox) => {
						checkBox
							.querySelector('.form__field')
							.addEventListener('change', () => {
								document
									.querySelectorAll('.vote-form .form-group')
									.forEach((box) => {
										if (
											box.classList.contains(
												'choice--active'
											)
										) {
											box.classList.remove(
												'choice--active'
											);
										}
									});
								checkBox.classList.add('choice--active');
							});
					});
			};

			const contrastPercent = () => {
				document.querySelectorAll('.choice-result').forEach((bar) => {
					const barColorSize = bar
						.querySelector('.bar div')
						.getAttribute('style');
					if (
						barColorSize === 'width: 98%' ||
						barColorSize === 'width: 99%' ||
						barColorSize === 'width: 100%'
					) {
						bar.querySelector('.percent').classList.add(
							'percent--white'
						);
					}
				});
			};

			// GO 🚀
			const init = () => {
				sondageResult();
				inputClick();
				inputCheck();
				contrastPercent();
			};

			$('.poll-view', context).once().each(init());
		},
	};
})(jQuery, Drupal, drupalSettings);
